import { createContext } from "react";
import type { IErrorHttpContext } from "./interfaces/IErrorHttpContext.interface";

const ErrorHttpContext = createContext<IErrorHttpContext | undefined>(undefined);
ErrorHttpContext.displayName = "ErrorHttpContext";

export { ErrorHttpContext };
